import { useEffect, useState } from 'react';

import {
  Modal,
  Paper,
  TextField,
  Grid,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

import { Unit } from 'types';
import { useSession } from 'providers/SessionProvider';
import { getUserFullName } from 'helpers';

type Props = {
  open: boolean;
  handleOpen: () => void;
  value: Unit | undefined;
  onEdit: (unit: Unit) => void;
};

export default function EditUnitModal({
  open = true,
  handleOpen,
  value,
  onEdit,
}: Props) {
  const { users } = useSession();
  const [data, setData] = useState<Unit>(value || {
    id: 0,
    description: '',
    is_active: true,
  });

  useEffect(() => {
    if (open) {
      setData(value || {
        id: 0,
        description: '',
        is_active: true,
      });
    }
  }, [open, value]);

  const handleChange = <K extends keyof Omit<Unit, 'id'>>(
    name: K,
    value: Omit<Unit, 'id'>[K]
  ) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSubmit = (updatedUnit: Unit) => {
    onEdit(updatedUnit);
  };

  return (
    <Modal open={open} onClose={handleOpen}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { sm: '90%', md: '30rem' },
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
        }}
      >
        <Grid container spacing={2}>
          <Typography variant='h5' gutterBottom>
            Editar unidad
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={data.is_active}
                  onChange={(e) => handleChange("is_active", e.target.checked)}
                  color="primary"
                />
              }
              label="Unidad de medida activa"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              id='outlined-required'
              label='Descripción'
              fullWidth
              value={data.description}
              onChange={e => handleChange('description', e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              disabled
              fullWidth
              label='Creado por'
              value={
                data.created_by
                  ? getUserFullName(data.created_by, users)
                  : 'SISTEMA'
              }
            />
          </Grid>
          <Grid item xs={12} display='flex' justifyContent='end' gap={1}>
            <Button
              type='button'
              variant='outlined'
              onClick={() => {
                handleOpen();
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='contained'
              onClick={() => {
                onSubmit(data);
                handleOpen();
              }}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Modal>
  );
}
